import { APIEntityType, type ArdoqId } from '@ardoq/api-types';
import type {
  EnhancedScopeData,
  FormattingAndLabelRules,
} from '@ardoq/data-model';
import type { I18nLocale } from '@ardoq/i18n';
import {
  getLabelsInterfaceForEnhancedScopeData,
  getLabelWithFormattingForViewsNotSupportingMultilabeling,
} from '@ardoq/graph';

export type ComponentLabelsArgs = {
  enhancedScopeData: EnhancedScopeData;
  componentIds: ArdoqId[];
  formattingAndLabelRules: FormattingAndLabelRules;
  i18nLocale: I18nLocale;
};

/** Each component's label under the viewpoint's label rules, first label only. */
export const toComponentLabels = ({
  enhancedScopeData,
  componentIds,
  formattingAndLabelRules,
  i18nLocale,
}: ComponentLabelsArgs): Map<ArdoqId, string> => {
  const labelsInterface = getLabelsInterfaceForEnhancedScopeData({
    enhancedScopeData,
    formattingFilters: formattingAndLabelRules.rules,
    i18nLocale,
  });

  return new Map(
    componentIds.map(componentId => [
      componentId,
      getLabelWithFormattingForViewsNotSupportingMultilabeling({
        modelId: componentId,
        entityLabel: enhancedScopeData.componentsById[componentId]?.name ?? '',
        entityType: APIEntityType.COMPONENT,
        i18nLocale,
        referenceLabelFilters: [],
        labelsInterface,
      }),
    ])
  );
};
